module.exports = __webpack_public_path__ + "img/scan (14).802d46e8.png";